import React from "react";

const HelpDesk = ({title}) => {
  document.title = title;
  return (
    <div className="bg-yellow-50 min-h-[calc(100vh-64px)] p-10">
      <div className="bg-white shadow-lg rounded-lg p-6 max-w-md  m-auto ">
        <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
          SUPPORT
        </h2>
        <p className="text-sm text-gray-600 mb-6 text-center">
          We're here to assist you! Reach out through any of the following
          options.
        </p>
        <div className="space-y-4">
          {/* Call Support */}
          <div className="flex items-center gap-4 p-4 border rounded-lg hover:bg-blue-50 transition">
            <i className="fas fa-phone text-blue-500"></i>
            <div>
              <a href="tel:+91-933-515-6415">
                <h3 className="text-lg font-medium text-gray-800">
                  Call Support
                </h3>
                <p className="text-sm text-gray-600">
                  Available Mon-Fri, 9:00 AM - 6:00 PM
                </p>
                <p className="text-sm text-blue-600 font-semibold">
                  +91-933-515-6415
                </p>
              </a>
            </div>
          </div>
          {/* WhatsApp Support */}
          <div className="flex items-center gap-4 p-4 border rounded-lg hover:bg-green-50 transition">
            <i className="fab fas text-xl fa-whatsapp text-green-500"></i>
            <div>
              <a
                href="https://wa.me/+918318306914"
                target="_blank"
                rel="noopener noreferrer"
                className=""
              >
                <h3 className="text-lg font-medium text-gray-800">
                  WhatsApp Support
                </h3>
                <p className="text-sm text-gray-600">Available anytime</p>

                <p className="text-sm text-green-600 font-semibold">
                  Chat on WhatsApp
                </p>
              </a>
            </div>
          </div>
          {/* Email Support */}
          <div className="flex items-center gap-4 p-4 border rounded-lg hover:bg-red-50 transition">
            <i className="fas fa-envelope text-red-500"></i>
            <div>
              <a href="mailto:support@clickstar.kansals.in">
                <h3 className="text-lg font-medium text-gray-800">
                  Email Support
                </h3>
                <p className="text-sm text-gray-600">Available anytime</p>
                <p className="text-sm text-red-600 font-semibold">
                  support@clickstar.kansals.in
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpDesk;
